import React, { Component } from "react";
import mongoose from '../Images/mongoose.png';
import '../Styles/Skills.css';

export default class Skills extends Component {
  render() {
    return (
      <section className="skills" id="skills">
        <h1 className="title-skills">Habilidades</h1>
        <div 
          className="skills-container"
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          <div className="skill-content">
            <i className="devicon-html5-plain"></i>
            <p>HTML</p>
          </div>
          <div className="skill-content">
            <i className="devicon-css3-plain"></i>
            <p>CSS</p>
          </div>
          <div className="skill-content">
            <i className="devicon-javascript-plain"></i>
            <p>JavaScript</p>
          </div>
          <div className="skill-content">
            <i className="devicon-react-original"></i>
            <p>React</p>
          </div>
          <div className="skill-content">
            <i className="devicon-redux-original"></i>
            <p>Redux</p>
          </div>
          <div className="skill-content">
            <i className="devicon-jest-plain"></i>
            <p>Jest</p>
          </div>
          <div className="skill-content">
            <i className="devicon-docker-plain"></i>
            <p>Docker</p>
          </div>
          <div className="skill-content">
            <i className="devicon-nodejs-plain"></i>
            <p>Node.js</p>
          </div>
          <div className="skill-content">
            <i className="devicon-typescript-plain"></i>
            <p>TypeScript</p>
          </div>
          <div className="skill-content">
            <i className="devicon-express-original"></i>
            <p>Express.js</p>
          </div>
          <div className="skill-content">
            <i className="devicon-mysql-plain"></i>
            <p>MySQL</p>
          </div>
          <div className="skill-content">
            <i className="devicon-sequelize-plain"></i>
            <p>Sequelize</p>
          </div>
          <div className="skill-content">
            <i className="devicon-mongodb-plain"></i>
            <p>MongoDB</p>
          </div>
          <div className="skill-content">
            <img src={ mongoose } alt="mongoose-logo"/>
            <p>Mongoose</p>
          </div>
          <div className="skill-content">
            <i className="devicon-mocha-plain"></i>
            <p>Mocha</p>
          </div>
        </div>          
      </section>
    )
  }
}